import type { ReactNode } from 'react';
import React, { createContext, useCallback, useEffect, useState } from 'react';
// import { useRouter } from 'next/router';
// import { Flex } from '@balance-web/flex';
// import { LoadingDots } from '@balance-web/loading';

// import { mfaTokenPrefix } from '../constants';

import type { PortalUser } from '../types/user';
import { tokenValidate } from '../lib/api';

export type MaybeUser = PortalUser | null;

export type AuthContextState = {
  user: MaybeUser;
  setUser: (user: MaybeUser) => void;

  onValidateAccessToken: (accessToken: string) => void;
};

export const AuthContext = createContext<AuthContextState | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  // const router = useRouter();
  const [user, setUser] = useState<PortalUser | null>(null);

  // const [sessionMfaKey, setSessionMfaKey] = useState('');

  useEffect(() => {}, []);

  const handleValidateAccessToken = useCallback(async (accessToken: string) => {
    const validateTokenResponse = await tokenValidate(accessToken);
    setUser({
      ...validateTokenResponse,
      token: accessToken,
    });
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        onValidateAccessToken: handleValidateAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
